export enum ERequestType {
  Store = "Store",

  Customer = "Customer",

  Courier = "Courier",

  Admin = "Admin",

  ServicePointSelfService = "ServicePointSelfService",

  Reseller = "Reseller",
}
